















import Vue from 'vue';
import SideBar from '../components/SideBar.vue';
import { Component, Emit } from 'vue-property-decorator';
import InicioPantalla from '@/pantallas/Inicio/InicioPantalla.vue';
import store from '@/store';
import ComponenteChat from '@/reusable/Chat/ComponenteChat.vue';

@Component({
  components: {
    InicioPantalla,
    'app-sidebar': SideBar,
    ComponenteChat,
  },
})
export default class Home extends Vue {
  fixed: boolean = false;
  mostrarChat: boolean = false;

  mounted() {
    this.permisosChat();
  }

  permisosChat() {
    if (store.state.permisoChat) {
      this.mostrarChat = true;
    } else {
      this.mostrarChat = false;
    }
  }
}
